import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription, tap } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  	providedIn: 'root'
})
export class Me implements OnDestroy {

	private subscriptions: Subscription = new Subscription();

	id: number  = null
	guid: string  = null
	azureId: string  = null
	matricule: number  = null
	nom: string  = null
	prenom: string  = null
	nomComplet: string  = null
	service: string  = null
	fonction: string  = null
	fonctionAndVille: string  = null
	ville: string  = null
	mail: string  = null
	mobile: string  = null
	telephone: string  = null
	fax: string  = null
	picture: string  = null
	preferences: any  = null
	connection: any = null
	etablissement_rattache: any = null
	etablissements_rattaches: any = null

	constructor(private apiService: ApiService) {

		this.subscriptions.add(
			this.apiService.onAuthenticated().subscribe(authenticated => {
				if(authenticated)
					Object.assign(this, this.apiService.me.pick(...Object.getOwnPropertyNames(this)))
			})
		)
	}

	get isAuthenticated(): boolean { return this.apiService.isAuthenticated; };
	get isGod(): boolean { return this.apiService.decodedToken?.isGod ?? false; };
	get isImpersonate(): boolean { return !!this.apiService.impersonated; };
	get isImpersonateGod(): boolean { return this.apiService.impersonateDecodedToken?.isGod ?? false; };

	impersonate (user: {guid: string}): Observable<any> { return this.apiService.impersonate(user); }
	personate () { this.apiService.personate(); }

	can (...roles: string[]): boolean {

		if(this.isGod)
			return this.isGod;
		else 
			return roles
					.map(role => {
						
						const [level, code] = role.split(/(?=[A-Z])(.+)/, 2);
						
						if(level === 'god')
							return this.isGod;
						
						return (this.apiService.decodedToken[`can${code}`] ?? 0) >= ['forbidden','read','edit','remove','manage','admin'].indexOf(level);
					})
					.reduce((acc, can) => acc || can, false);
	}

	update: Subject<{me: any, token: string}> = new Subject();
	onUpdate: Observable<{me: any, token: string}> = this.update.asObservable().pipe(tap(data => this.apiService.refresh(data))); 

	setPreference (name: string, value: any): Observable<any> {
		return this.apiService
					.post('me/preference', {name, value})
					.pipe(tap(preferences => {
						this.apiService.me = {me: {...this.apiService.me, preferences}};
						this.apiService.onAuthenticatedSubject.next(true);
					}));
	}

	ngOnDestroy () {
		this.subscriptions.unsubscribe();
	}
}